<!--
  과정 큐래이션 목록 컴포넌트
-->
<template>
  <section
    :style="setStyle"
    class="section_home course_curation"
  >
    <div class="inner">
      <div
        v-if="curationData !== null"
        ref="mmpCourseCuration"
        :id="idPrefix + cuId"
        :class="['mmp_course_curation', classes]"
        :data-default-type="cuTypePc"
      >
        <!-- curation header -->
        <div class="cu_header">

          <!-- title -->
          <h2>
            <span v-if="showCuTitle" class="txt" v-html="cuTitle" />
          </h2>
          <!-- // title -->

          <!-- 더보기 -->
          <button
            v-if="!isTabList && showElement.moreBtn.current === 'Y'"
            type="button"
            class="btn_more"
            @click="getMoreList"
          >{{ moreBtnTxt }}</button>
          <!-- // 더보기 -->

        </div>
        <!-- // curation header -->

        <!-- tab list -->
        <div
          v-if="isTabList"
          ref="tabListSwiper"
          class="wrap_tab_list swiper-container"
        >
          <div class="inner swiper-wrapper">
            <div
              v-for="(item, index) in curationTabData"
              :key="index"
              class="tab_item swiper-slide"
            >
              <button
                :data-tab-id="item.id"
                :class="['btn_tab', {'active' : index === 0}]"
                type="button"
                @click="clickTab($event, item)"
              >{{ item.title }}</button>
            </div>
          </div>

          <!-- 좌우 부드럽게 사라지게 표현되는 영역 -->
          <div :style="tabBgColorStr('left')" class="fade left"/>
          <div :style="tabBgColorStr('right')" class="fade right"/>
          <!-- // 좌우 부드럽게 사라지게 표현되는 영역 -->
        </div>
        <!-- // tab list -->

        <!-- curation content -->
        <div
          :class="[
            'cu_content',
            {'tab_content': isTabList},
            isTabList ? `column_${columns}` : ''
          ]"
        >

          <!-- 큐레이션 리스트 -->
          <div ref="mmpCuration" class="curation_container">
            <div v-if="isVisable" class="curation_wrapper">
              <div
                v-for="(item, index) in visibleItems"
                :key="index"
                class="st_item"
              >
                <a
                  href="javascript:void(0)"
                  class="st_link"
                  @click="openDetail(item)"
                >

                  <!-- 과정목록 아이템 컴포넌트 -->
                  <CompCourseItem
                    :crtn-typ="crtnTyp"
                    :course-item="item"
                    :gallery-size="gallerySize"
                    :list-type="listType.current === 'visual' ? 'list' : listType.current"
                    :list-type-mo="listType.current"
                    :max-setup-num="potltInfo.potltData[0].maxSetupNum"
                    :show-date="showDate"
                    :show-footer="false"
                    :show-html-title="showHtmlTitle"
                    :show-label="showLabel"
                    :show-review="showElement.review.current === 'Y'"
                    :show-tag="showElement.tag.current === 'Y'"
                  />
                  <!-- // 과정목록 아이템 컴포넌트 -->

                </a>
              </div>
            </div>
            <div v-else class="curation_wrapper">
              <li>데이터가 없습니다.</li>
            </div>
          </div>
          <!-- // 큐레이션 리스트 -->

          <!-- 스와이퍼용 내비게이션 -->
          <div
            v-if="listType.current !== 'list'"
            class="swiper_nav"
          >
            <div
              v-show="curationData !== null && isDesktop && crtnTyp !== 'TAB'"
              class="swiper-button-prev"
            />
            <div
              v-show="curationData !== null && isDesktop && crtnTyp !== 'TAB'"
              class="swiper-button-next"
            />
          </div>
          <!-- // 스와이퍼용 내비게이션 -->

          <!-- 더보기 버튼 (탭 콘텐츠 더보기) -->
          <!--        v-if="isTabList && isVisable && showMoreButton"-->
          <div
            v-if="isTabList && isVisable && showMoreButton"
            class="wrap_more_btn"
          >
            <button
              type="button"
              class="btn_load_more"
              @click="loadMoreContent()"
            >{{ moreTitle }} 강의 더보기</button>
          </div>
          <!-- // 더보기 버튼 (탭 콘텐츠 더보기) -->

        </div>
        <!-- // curation content -->

      </div>
    </div>
  </section>
</template>

<script>
import { isEmpty } from 'lodash'
import commonMixin from '@/mixin/commonMixin'
import SubCorsList from '~pages/nrw/common/SubCorsList'
import CompCourseItem from '~pages/nrw/portlet/CompCourseItem'
import 'swiper/dist/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import MotionEffects from '/src/assets/js/MotionEffects'

export default {
  name: 'UserCuration',
  components: {
    SubCorsList,
    Swiper,
    SwiperSlide,
    CompCourseItem
  },
  mixins: [commonMixin, MotionEffects],
  props: {
    crtnTyp: {
      type: String,
      default: 'BAS'
    },
    potltInfo: {
      type: Object,
      default: null
    },
    // 큐레이션 고유번호
    cuId: {
      type: String,
      default: null
    },
    cuTitle: {
      type: String,
      default: ''
    },
    cuType: {
      type: String,
      default: 'gallery'
    },
    swiper: {
      type: String,
      default: 'Y'
    },
    cuTypeMobile: {
      type: String,
      default: ''
    },
    cuTypeTablet: {
      type: String,
      default: ''
    },
    cuTypePc: {
      type: String,
      default: ''
    },
    gallerySize: {
      type: String,
      default: 'medium'
    },
    showCuTitle: {
      type: Boolean,
      default: true
    },
    showDate: {
      type: Boolean,
      default: true
    },
    showLabel: {
      type: String,
      default: 'Y'
    },
    showLabelMobile: {
      type: String,
      default: ''
    },
    showLabelTablet: {
      type: String,
      default: ''
    },
    showLabelPc: {
      type: String,
      default: ''
    },
    showReview: {
      type: String,
      default: 'Y'
    },
    showReviewMobile: {
      type: String,
      default: ''
    },
    showReviewTablet: {
      type: String,
      default: ''
    },
    showReviewPc: {
      type: String,
      default: ''
    },
    showTag: {
      type: String,
      default: 'Y'
    },
    showTagMobile: {
      type: String,
      default: ''
    },
    showTagTablet: {
      type: String,
      default: ''
    },
    showTagPc: {
      type: String,
      default: ''
    },
    showMoreBtn: {
      type: String,
      default: 'Y'
    },
    showMoreBtnMobile: {
      type: String,
      default: ''
    },
    showMoreBtnTablet: {
      type: String,
      default: ''
    },
    showMoreBtnPc: {
      type: String,
      default: ''
    },
    showHtmlTitle: { // 타이틀 영역 노출 여부
      type: Boolean,
      default: false
    },
    moreBtnTxt: {
      type: String,
      default: '더보기'
    },
    slidesPerViewMobile: {
      type: String,
      default: 'auto'
    },
    slidesPerViewTablet: {
      type: String,
      default: 'auto'
    },
    slidesPerViewPc: {
      type: Number,
      default: 3
    },
    columnsMobile: {
      type: Number,
      default: 1
    },
    columnsTablet: {
      type: Number,
      default: 2
    },
    columnsPc: {
      type: Number,
      default: 2
    },
    tabBgColor: {
      type: String,
      default: '#fff'
    }
  },
  data () {
    return {
      visibleCount: '',
      moreTitle: '',
      isVisable: true,
      tabList: [], // 탭 목록
      tabData: {}, // 탭 데이터를 저장하는 객체
      potltData: {}, // 포틀릿 기본 데이터
      idPrefix: 'curation_', // wrapper ID 앞에 추가되는 고정 값 (id="curation_'큐레이션고유번호''")
      classes: {},
      listType: {
        current: '',
        mobile: '',
        tablet: '',
        pc: ''
      },
      isTabList: false,
      columns: 1,
      showElement: {
        label: {
          current: '',
          mobile: '',
          tablet: '',
          pc: ''
        },
        review: {
          current: '',
          mobile: '',
          tablet: '',
          pc: ''
        },
        tag: {
          current: '',
          mobile: '',
          tablet: '',
          pc: ''
        },
        moreBtn: {
          current: '',
          mobile: '',
          tablet: '',
          pc: ''
        }
      },
      curationTabData: {},
      curationData: {}, // 큐레이션 데이터
      // 탭메뉴 스와이퍼 옵션
      tabSwiper: {
        instance: null,
        option: {
          slidesPerView: 'auto',
          spaceBetween: 6,
          freeMode: true
        }
      },
      swiperActiveIndex: 1,
      // 'cuType' 이 'visual' 인 경우 고정 옵션값 사용
      visualSwiper: {
        option: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 10,
          preloadImages: true,
          navigation: {
            prevEl: `#curation_${this.cuId} .swiper-button-prev`,
            nextEl: `#curation_${this.cuId} .swiper-button-next`
          },
          on: {
            init: () => {
              this.setVisualActiveIndex()
            },
            slideChange: () => {
              this.setVisualActiveIndex()
            }
          }
        }
      },
      // 콘텐츠 스와이퍼 옵션
      cuSwiper: {
        instance: null,
        option: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 18,
          responsive: true,
          preloadImages: true,
          loop: false,
          navigation: {
            prevEl: `#curation_${this.cuId} .swiper-button-prev`,
            nextEl: `#curation_${this.cuId} .swiper-button-next`
          },
          breakpoints: {
            /* mobile */
            499: {
              slidesPerView: 'auto',
              slidesPerGroup: 1,
              spaceBetween: 16
            },
            /* tablet */
            1200: {
              slidesPerView: 'auto',
              slidesPerGroup: 1,
              spaceBetween: 16
            }
          }
        }
      },
      // 탭 리스트 스와이퍼 옵션
      tabListSwiper: {
        instance: null,
        option: {
          slidesPerView: 'auto',
          spaceBetween: 6,
          freeMode: true
        }
      }
    }
  },
  computed: {
    // 초기 보여지는 항목 수
    maxSetupNum () {
      return this.potltData.maxSetupNum * 5
    },
    // 보이는 항목
    visibleItems () {
      if (this.curationData && this.curationData.data) {
        const maxCount = this.crtnTyp === 'TAB' ? this.visibleCount : this.maxSetupNum
        return this.curationData.data.slice(0, maxCount)
      }
      return []
    },
    showMoreButton () {
      let result
      if (this.curationData.data) {
        result = this.visibleItems.length < this.curationData.data.length
      }
      return result
    },
    deviceType () { // 화면 사이즈 기분 디바이스 타입 구분 (pc, tablet, mobile)
      return window.vue.getStore('homeInfo').state.deviceType
    },
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
    },
    setStyle () {
      return {
        padding: !this.isDesktop ? '40px 0' : `${this.potltData.btomGapNum}px 0`,
        backgroundColor: this.potltData.potltBgColorCd
      }
    }
  },
  watch: {
    'deviceType': {
      handler: function (nVal, oVal) {
        this.setCurationUi()
        this.initCuSwiper()
      }
    },
    'listType.current': {
      handler: function (nVal, oVal) {
        if (nVal !== oVal) {
          if (this.listType.current === 'list') {
            this.destroyCuSwiper()
          } else {
            this.initCuSwiper()
          }
        }
      }
    }
  },
  beforeCreate () {

  },
  created () {
    this.setDataFromProps()
    this.setCurationUi()

    this.initializeCurationData()
  },
  beforeMount () {

  },
  mounted () {
    this.getCurationTabData() // 큐레이션 탭 데이터 설정

    // 초기 보여지는 항목 수 설정
    this.visibleCount = this.slidesPerViewPc

    // 초기 더보기 텍스트 설정
    this.moreTitle = this.curationTabData[0].title

    // 첫 번째 탭 클릭
    this.$nextTick(() => {
      this.clickFirstTab()
    })

    // visual 타입인 경우 스와이퍼 슬라이드 클릭 이벤트 처리
    // if (this.listType.current === 'visual') this.addEvt()
  },
  beforeUpdate () {

  },
  updated () {

  },
  beforeDestroy () {
    this.destroyCuSwiper()
    this.destroyTabListSwiper()
    if (this.listType.current === 'visual') this.removeEvt()
  },
  methods: {
    // 특정 엘리먼트의 부모 클래스가 일치하는지 여부 확인
    checkParent (parentClass, target) {
      let node = target.parentNode
      while (node != null) {
        if (node.classList.contains(parentClass)) {
          return true
        }
        node = node.parentNode
      }
      return false
    },
    addEvt () {
      this.$nextTick(() => {
        window.addEventListener('click', (e) => {
          const bannerId = this.idPrefix + this.cuId
          const bannerWrapper = document.querySelector(`#${bannerId} .swiper-container`)
          const target = e.target

          if (bannerWrapper && bannerWrapper.contains(target)) {
            if (target.classList.contains('st_item') || this.checkParent('st_item', target)) {
              this.openDetail2()
            }
          }
        })
      })
    },
    removeEvt () {
      window.removeEventListener('click', this.addEvt)
    },
    initializeCurationData () {
      if (isEmpty(this.potltInfo)) return

      const { potltData, tabList, corsList } = this.potltInfo
      this.potltData = potltData[0]
      this.crtnTyp = this.potltData.crtnTyp

      // tabList의 요소를 변환하여 id와 title만 포함하도록 설정
      this.tabList = tabList.map(tab => ({
        title: tab.tabNm,
        id: tab.crtnSysopTabSno
      }))

      this.moreBtnText = this.tabList.length ? this.tabList[0].title : ''

      // 모든 큐레이션 데이터를 미리 불러오기
      if (this.crtnTyp === 'TAB' && this.tabList.length) {
        this.tabData = {} // tabData 초기화

        this.tabList.forEach(tab => {
          const matchedCors = corsList.filter(cors => cors.crtnSysopTabSno === tab.id)

          if (matchedCors.length) {
            this.tabData[tab.id] = matchedCors
          }
        })

        // 초기 큐레이션 데이터 설정 (첫 번째 탭 데이터로 설정)
        this.updateCurationContent(this.tabList[0].id)
      }

      this.$nextTick(() => {
        if (!this.potltInfo || !this.potltInfo.corsList) {
          console.error('큐레이션 데이터를 불러오는 중 오류 발생')
          return
        }

        this.curationData = {
          title: this.potltInfo.potltNm,
          link: '/course/totalCorsList',
          data: this.potltInfo.corsList.map(this.transformCourseData)
        }

        this.initCuSwiper()
      })
    },
    // swiper activeIndex 설정
    setVisualActiveIndex () {
      this.$nextTick(() => {
        const swiperInstance = this.cuSwiper.instance

        if (swiperInstance) {
          this.swiperActiveIndex = swiperInstance.realIndex + 1
        }
      })
    },
    clickFirstTab () {
      const tabListWrapper = this.$refs.tabListSwiper
      if (tabListWrapper) {
        const firstTab = tabListWrapper.querySelector('.btn_tab')
        if (firstTab) {
          firstTab.click() // 첫 번째 탭 클릭
        }
      }
    },
    // props 값 기준으로 data 값 설정
    setDataFromProps () {
      // listType
      this.listType = {
        current: this.cuType,
        mobile: this.cuType,
        tablet: this.cuType,
        pc: this.cuType
      }
      if (this.cuTypeMobile !== '') this.listType.mobile = this.cuTypeMobile
      if (this.cuTypeTablet !== '') this.listType.tablet = this.cuTypeTablet
      if (this.cuTypePc !== '') this.listType.pc = this.cuTypePc

      // label YN
      this.showElement.label = {
        current: this.showLabel,
        mobile: this.showLabel,
        tablet: this.showLabel,
        pc: this.showLabel
      }
      if (this.showLabelMobile !== '') this.showElement.label.mobile = this.showLabelMobile
      if (this.showLabelTablet !== '') this.showElement.label.tablet = this.showLabelTablet
      if (this.showLabelPc !== '') this.showElement.label.pc = this.showLabelPc

      // review YN
      this.showElement.review = {
        current: this.showReview,
        mobile: this.showReview,
        tablet: this.showReview,
        pc: this.showReview
      }
      if (this.showReviewMobile !== '') this.showElement.review.mobile = this.showReviewMobile
      if (this.showReviewTablet !== '') this.showElement.review.tablet = this.showReviewTablet
      if (this.showReviewPc !== '') this.showElement.review.pc = this.showReviewPc

      // tag YN
      this.showElement.tag = {
        current: this.showTag,
        mobile: this.showTag,
        tablet: this.showTag,
        pc: this.showTag
      }
      if (this.showTagMobile !== '') this.showElement.tag.mobile = this.showTagMobile
      if (this.showTagTablet !== '') this.showElement.tag.tablet = this.showTagTablet
      if (this.showTagPc !== '') this.showElement.tag.pc = this.showTagPc

      // moreBtn YN
      this.showElement.moreBtn = {
        current: this.showMoreBtn,
        mobile: this.showMoreBtn,
        tablet: this.showMoreBtn,
        pc: this.showMoreBtn
      }
      if (this.showMoreBtnMobile !== '') this.showElement.moreBtn.mobile = this.showMoreBtnMobile
      if (this.showMoreBtnTablet !== '') this.showElement.moreBtn.tablet = this.showMoreBtnTablet
      if (this.showMoreBtnPc !== '') this.showElement.moreBtn.pc = this.showMoreBtnPc
    },
    setCurationUi () {
      switch (this.deviceType) {
        case 'pc':
          this.listType.current = this.listType.pc
          this.showElement.label.current = this.showElement.label.pc
          this.showElement.review.current = this.showElement.review.pc
          this.showElement.tag.current = this.showElement.tag.pc
          this.showElement.moreBtn.current = this.showElement.moreBtn.pc
          this.cuSwiper.option.slidesPerView = this.slidesPerViewPc
          this.cuSwiper.option.slidesPerGroup = this.slidesPerViewPc
          this.columns = this.columnsPc
          break
        case 'tablet':
          this.listType.current = this.listType.tablet
          this.showElement.label.current = this.showElement.label.tablet
          this.showElement.review.current = this.showElement.review.tablet
          this.showElement.tag.current = this.showElement.tag.tablet
          this.showElement.moreBtn.current = this.showElement.moreBtn.tablet
          this.cuSwiper.option.breakpoints[1200].slidesPerView = 'auto'
          this.cuSwiper.option.breakpoints[1200].slidesPerGroup = this.gallerySize === 'small' ? 2 : 1
          this.columns = this.columnsTablet
          break
        case 'mobile':
          this.listType.current = this.listType.mobile
          this.showElement.label.current = this.showElement.label.mobile
          this.showElement.review.current = this.showElement.review.mobile
          this.showElement.tag.current = this.showElement.tag.mobile
          this.showElement.moreBtn.current = this.showElement.moreBtn.mobile
          this.cuSwiper.option.breakpoints[499].slidesPerView = 'auto'
          this.cuSwiper.option.breakpoints[499].slidesPerGroup = this.gallerySize === 'small' ? 2 : 1
          this.columns = this.columnsMobile
          break
        default:
          this.listType.current = this.listType.pc
          this.showElement.label.current = this.showElement.label.pc
          this.showElement.review.current = this.showElement.review.pc
          this.showElement.tag.current = this.showElement.tag.pc
          this.showElement.moreBtn.current = this.showElement.moreBtn.pc
          this.cuSwiper.option.slidesPerView = this.slidesPerViewPc
          this.cuSwiper.option.slidesPerGroup = this.slidesPerViewPc
          this.columns = this.columnsPc
      }

      this.classes = [
        this.listType.current,
        this.deviceType,
        this.listType.current === 'gallery' ? this.gallerySize : ''
      ]
    },
    // 큐레이션 탭 데이터 설정
    getCurationTabData () {
      this.curationTabData = this.tabList

      if (this.curationTabData.length > 1) {
        this.isTabList = true
        this.getTabContent()
        this.initTabListSwiper()
      }
    },
    // 큐레이션 데이터 설정
    transformCourseData (course) {
      return {
        courseTitle: this.potltInfo.potltNm,
        ...course,
        title: course.prdtNm,
        thumbPc: course.thumbLinkUrl,
        thumbMo: course.thumbLinkUrl,
        link: course.corsCd,
        label: [
          ...(course.prdtAttrTypNm ? [course.prdtAttrTypNm === '일반이러닝' ? '이러닝' : course.prdtAttrTypNm === '실시간' ? '비대면' : course.prdtAttrTypNm] : []),
          ...(course.diflvTypNm ? [course.diflvTypNm] : []),
          ...(course.txtbkNm ? [course.txtbkNm] : [])
        ],
        // ;와 #를 ,로 치환
        tag: course.srchKwrdCntnt ? course.srchKwrdCntnt.replace(/;|#/g, ',').split(',').map(tag => tag.trim()) : [],
        schedule: course.eduDtm ? course.eduDtm.split(',').map(date => date.trim()) : [],
        rating: course.evalAvg ? course.evalAvg.toString() : '0',
        review: course.evalCnt ? course.evalCnt.toString() : '0'
      }
    },
    updateCurationContent (tabId) {
      this.isVisable = true

      const filteredContent = this.tabData[tabId]

      if (filteredContent) {
        this.curationData.data = filteredContent.map(this.transformCourseData)
      } else {
        // console.log('데이터 없음')
        this.isVisable = false
        this.curationData.data = []
      }
    },
    // 더보기 버튼 클릭 메서드
    getMoreList () {
      const cuId = this.cuId
      const url = this.curationData.link

      // NOTE: 더보기 기능 처리
      console.log('큐레이션 ID : ', cuId)
      console.log('url: ', url)

      this.$goPage({'name': 'allCorsList', query: {total: this.curationData.title}})

      localStorage.removeItem('allCorsList')
      localStorage.removeItem('allCorsListOptionsState')
      localStorage.setItem('allCorsList', JSON.stringify(this.curationData.data))
    },
    addSwiperClass () {
      if (this.swiper === 'Y') {
        const swiperContainer = this.$refs.mmpCuration
        const swiperWrapper = swiperContainer.querySelector('.curation_wrapper')
        const swiperSlides = swiperContainer.querySelectorAll('.st_item')
        let i, swiperSlide

        swiperContainer.classList.add('swiper-container')
        swiperWrapper.classList.add('swiper-wrapper')

        for (i = 0; i < swiperSlides.length; i++) {
          swiperSlide = swiperSlides[i]
          swiperSlide.classList.add('swiper-slide')
        }
      }
    },
    removeSwiperClass () {
      if (this.swiper === 'Y') {
        const swiperContainer = this.$refs.mmpCuration
        const swiperWrapper = swiperContainer.querySelector('.curation_wrapper')
        const swiperSlides = swiperContainer.querySelectorAll('.st_item')
        let i, swiperSlide

        swiperContainer.classList.remove('swiper-container')
        swiperWrapper.classList.remove('swiper-wrapper')

        for (i = 0; i < swiperSlides.length; i++) {
          swiperSlide = swiperSlides[i]
          swiperSlide.classList.remove('swiper-slide')
        }
      }
    },
    // 큐레이션 스와이퍼 초기화
    initCuSwiper () {
      this.$nextTick(() => {
        if (this.swiper === 'Y' && this.listType.current !== 'list') {
          const swiperContainer = this.$refs.mmpCuration
          const swiperOption = this.listType.current === 'visual' ? this.visualSwiper.option : this.cuSwiper.option

          this.destroyCuSwiper()
          this.addSwiperClass()

          this.cuSwiper.instance = new Swiper(swiperContainer, swiperOption)

          setTimeout(() => {
            this.updateCuSwiper()
          }, 400)
        }
      })
    },
    // 큐레이션 스와이퍼 업데이트
    updateCuSwiper () {
      const swiperInstance = this.cuSwiper.instance
      if (swiperInstance) swiperInstance.update()
    },
    // 큐레이션 스와이퍼 해제
    destroyCuSwiper () {
      const swiperInstance = this.cuSwiper.instance
      if (swiperInstance) swiperInstance.destroy()
      this.removeSwiperClass()
    },
    // 탭 리스트 스와이퍼 UI 설정
    initTabListSwiper () {
      setTimeout(() => {
        const swiperContainer = this.$refs.tabListSwiper
        this.swiperInstance = new Swiper(swiperContainer, this.tabListSwiper.option)
      }, 400)
    },
    // 탭 리스트 스와이퍼 업데이트
    updateTabListSwiper () {
      const swiperInstance = this.tabListSwiper.instance
      if (swiperInstance) swiperInstance.update()
    },
    // 탭 리스트 스와이퍼 해제
    destroyTabListSwiper () {
      const swiperInstance = this.tabListSwiper.instance
      if (swiperInstance) swiperInstance.destroy()
    },
    // 탭 버튼 클릭 이벤트 (활성 탭 변경)
    clickTab (event, item) {
      const tabListWrapper = this.$refs.tabListSwiper
      const tabs = tabListWrapper.querySelectorAll('.btn_tab')

      // 모든 탭의 활성화 클래스 제거
      tabs.forEach(tab => {
        tab.classList.remove('active')
      })

      // 클릭한 탭에 활성화 클래스 추가
      event.currentTarget.classList.add('active')

      // 탭 콘텐츠 업데이트
      this.getTabContent()
      this.moreTitle = item.title
      this.visibleCount = this.potltData.maxSetupNum
    },
    // 활성 탭의 콘텐츠 설정
    getTabContent () {
      this.$nextTick(() => {
        const curationWrapper = this.$refs.mmpCourseCuration
        const tabListWrapper = this.$refs.tabListSwiper
        const tabs = tabListWrapper.querySelectorAll('.btn_tab')
        const moreBtn = curationWrapper.querySelector('.btn_load_more')
        let tabId, tabTitle

        // 전체 탭 목록에서 활성화 된 탭 캐치
        for (let i = 0; i < tabs.length; i++) {
          if (tabs[i].classList.contains('active')) {
            tabId = tabs[i].getAttribute('data-tab-id') // 탭 ID
            tabTitle = tabs[i].textContent // 탭 타이틀

            // 더보기 버튼 텍스트 변경
            if (moreBtn) {
              moreBtn.textContent = `${tabTitle} ${this.moreBtnTxt}`
            }
          }
        }

        // NOTE: 탭 ID 기준으로 콘텐츠 변경
        // console.log('getTabContent: tabId:', tabId)
        this.updateCurationContent(tabId)
      })
    },
    // 더보기 버튼 클릭 (콘텐츠 더보기)
    loadMoreContent () {
      // const tabId = this.currentTabId

      // NOTE: 탭 ID 기준으로 콘텐츠 더보기
      // console.log('loadMoreContent: tabId:', tabId)

      this.visibleCount += this.visibleCount
    },
    hexToRgb (hex) {
      const tmpHex = hex.replace('#', '')
      if (tmpHex.length === 3) hex = `#${tmpHex + tmpHex}`
      const regEx = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      const rgbTxt = `${parseInt(regEx[1], 16)}, ${parseInt(regEx[2], 16)}, ${parseInt(regEx[3], 16)}`
      return regEx ? rgbTxt : 'transparent'
    },
    // 탭 메뉴 좌우측 부드럽게 사라지게 표현하기 위한 색상값 반환
    tabBgColorStr (pos) {
      const baseRgbStr = 'rgba(255, 255, 255, 0)'
      const rgbStr = `rgba(${this.hexToRgb(this.tabBgColor)}, 1)`
      let deg

      if (pos === 'left') {
        deg = 270
      } else {
        deg = 90
      }

      return `background:linear-gradient(${deg}deg, ${baseRgbStr} 0%, ${rgbStr} 50%)`
    },
    // 과정 상세
    openDetail (courseItem) {
      this.$goPage({name: 'CrsDetail', query: { corsCd: courseItem.link }})
    },
    // 스와이퍼인 경우 과정 상세 바로가기 (swiper-duplicate 이슈로 이벤트 안걸리는 문제 우회 처리)
    openDetail2 () {
      this.$nextTick(() => {
        const idx = this.swiperActiveIndex - 1
        this.$goPage({name: 'CrsDetail', query: { corsCd: this.visibleItems[idx].link }})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/UserCuration.vue